export default function Star({ className }: { className ?: string}) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='110'
        height='22'
        viewBox='0 0 110 22'
        fill='none'
        className={className}
      >
        <g clipPath='url(#clip0_505_2839)'>
          <path
            d='M10.5797 2.03418L13.3033 7.51167L19.3938 8.39543L14.9868 12.6567L16.0268 18.6767L10.5797 15.8329L5.13261 18.6767L6.17268 12.6567L1.76562 8.39543L7.85617 7.51167L10.5797 2.03418Z'
            fill='#FF9900'
          />
          <path
            d='M33.8453 2.03418L36.5689 7.51167L42.6594 8.39543L38.2524 12.6567L39.2924 18.6767L33.8453 15.8329L28.3982 18.6767L29.4382 12.6567L25.0312 8.39543L31.1218 7.51167L33.8453 2.03418Z'
            fill='#FF9900'
          />
          <path
            d='M57.1188 2.03418L59.8423 7.51167L65.9328 8.39543L61.5258 12.6567L62.5659 18.6767L57.1188 15.8329L51.6716 18.6767L52.7117 12.6567L48.3047 8.39543L54.3952 7.51167L57.1188 2.03418Z'
            fill='#FF9900'
          />
          <path
            d='M80.3844 2.03418L83.1079 7.51167L89.1985 8.39543L84.7915 12.6567L85.8315 18.6767L80.3844 15.8329L74.9373 18.6767L75.9773 12.6567L71.5703 8.39543L77.6608 7.51167L80.3844 2.03418Z'
            fill='#FF9900'
          />
          <mask
            id='mask0_505_2839'
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x='93'
            y='2'
            width='18'
            height='18'
          >
            <path d='M110.001 2.38477H93.0781V19.1848H110.001V2.38477Z' fill='white' />
          </mask>
          <g mask='url(#mask0_505_2839)'>
            <path
              d='M97.178 17.0992L101.536 14.8241V3.78516L99.3568 8.16716L94.4844 8.87416L98.0101 12.2831L97.178 17.0992Z'
              fill='#FF9900'
            />
            <path
              d='M101.536 3.78516L103.715 8.16716L108.587 8.87416L105.061 12.2831L105.894 17.0992L101.536 14.8241L97.178 17.0992L98.0101 12.2831L94.4844 8.87416L99.3568 8.16716L101.536 3.78516Z'
              stroke='#FF9900'
              strokeLinecap='round'
            />
          </g>
        </g>
        <defs>
          <clipPath id='clip0_505_2839'>
            <rect width='110' height='21' fill='white' transform='translate(0 0.285156)' />
          </clipPath>
        </defs>
      </svg>
    );
  }
  